import { useEffect, useState } from "react";
import * as http from "../../../../utils/http";
import * as translator from "../../../../utils/translator";
import CarePlusCategoryCard from "./CarePlusCategoryCard";

interface CarePlusCrossSellProps {
    language?: string;
    country?: string;
}

const TARGET_CATEGORY_MENTIONS = ["hair_loss", "asthma", "diabetes_typ_2", "medical_cannabis"];

const getAssetUrl = (relativePath: string) => {
    const assetBasePath = (window as any).clientConfig?.assetBasePath || "https://images.doktorabc.com/redesign_2025";
    return `${assetBasePath}/${relativePath}`;
};

export default function CarePlusCrossSell({ language, country }: CarePlusCrossSellProps) {

    const [categories, setCategories] = useState<SidebarTopCategory[]>([]);

    useEffect(() => {

        http.getFromServer(`header/${country}/${language}`, [http.MIDDLEWARES.CUSTOMER_ID])
            .then((response) => {
                const sidebarTopCategories: SidebarTopCategory[] = response.data.sidebarTopCategoriesV2 || [];
                const matchedCategories = TARGET_CATEGORY_MENTIONS
                    .map((mention) => sidebarTopCategories.find((category) => (category.mention === mention) || (category.assetMention === mention)))
                    .filter((category): category is SidebarTopCategory => !!category);

                setCategories(matchedCategories);
            })
            .catch((err) => {
                window.clientLogger.error("CarePlusCrossSell get header error", err);
            });

    }, []);

    if (!categories.length) {
        return null;
    }

    return (
        <div className="care-plus-crosssell">
            <div className="care-plus-crosssell-banner">
                <div className="care-plus-crosssell-photo">
                    <img src={getAssetUrl("care-plus/thank-you-page/hero-mobile/hero-mobile.png")} alt="" />
                </div>
                <div className="care-plus-crosssell-text">
                    <p className="care-plus-crosssell-title">
                        {translator.translate(language, "thankyou", "page/care_plus_crosssell_title")}
                    </p>
                    <p className="care-plus-crosssell-subtitle">
                        {translator.translate(language, "thankyou", "page/care_plus_crosssell_subtitle")}
                    </p>
                </div>
            </div>
            <div className="care-plus-crosssell-grid">
                {categories.map((category) => (
                    <CarePlusCategoryCard key={category.mention} category={category} />
                ))}
            </div>
        </div>
    )
}
